import { Box, Button, Container, Grid, Stack } from "@mui/material";
import {
  STRINGS_LOAD_MORE,
  STRINGS_SEARCH,
} from "../../../data/strings/Strings";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import { Search } from "@mui/icons-material";
import { CustomersViewModel } from "./CustomersViewModel";
import { CustomersListItemView } from "./listItemView/CustomersListItemView";
import { CustomTextField } from "../../component/CustomTextField";
import { HeaderView } from "../../component/HeaderView";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { LoadingView } from "../../component/LoadingView";
import { EmptyView } from "../../component/EmptyView";
import { CustomTextView } from "../../component/CustomTextView";
import {
  provideGetAllCustomersUseCase,
  provideSearchCustomersUseCase,
} from "../../di/UseCasesModule";

export function CustomersView() {
  const viewModel = CustomersViewModel(
    provideGetAllCustomersUseCase(),
    provideSearchCustomersUseCase()
  );
  const { width } = useWindowDimensions();
  return (
    <Box>
      <Stack spacing={2}>
        <HeaderView
          title={"Customers"}
          layout={
            <Box
              component={"form"}
              onSubmit={(e) => {
                e.preventDefault();
                viewModel.searchCompanies();
              }}
            >
              <CustomTextField
                required
                type="search"
                value={viewModel.searchText}
                placeholder={"Search by name or email"}
                onTextChange={(txt) => {
                  viewModel.setSearchText(txt);
                }}
                startIcon={<Search sx={{ color: COLOR_LIGHT_GRAY }} />}
              />
            </Box>
          }
        />
        <Container maxWidth={false}>
          {viewModel.isLoading ? (
            <LoadingView />
          ) : (
            <>
              {viewModel.customers && (
                <>
                  {viewModel.customers.length === 0 ? (
                    <EmptyView />
                  ) : (
                    <Grid container spacing={1} pt={1} pb={3}>
                      {viewModel.customers.map((customer, index) => {
                        return (
                          <Grid
                            size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}
                            key={customer._id}
                          >
                            <CustomersListItemView
                              isVertical={width < 1000}
                              customer={customer}
                              index={index}
                            />
                          </Grid>
                        );
                      })}
                      <Grid
                        alignItems={"center"}
                        justifyContent={"center"}
                        display={"flex"}
                        size={12}
                      >
                        {viewModel.showLoadMoreLoading ? (
                          <LoadingView minHeight="5vh" />
                        ) : (
                          <>
                            {viewModel.showLoadMoreButton && (
                              <Button
                                variant="outlined"
                                sx={{
                                  borderRadius: 22,
                                  textTransform: "none",
                                  borderColor: COLOR_BLACK,
                                  "&:hover": {
                                    borderColor: COLOR_BLACK,
                                    background: COLOR_LIGHT_GRAY,
                                  },
                                }}
                                onClick={viewModel.getCustomers}
                              >
                                <CustomTextView
                                  text={STRINGS_LOAD_MORE}
                                  variant="h6"
                                  fontWeight="bold"
                                />
                              </Button>
                            )}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
        </Container>
      </Stack>
    </Box>
  );
}
